import { render, staticRenderFns } from "./Businessagreement.vue?vue&type=template&id=202caba8&"
import script from "./Businessagreement.vue?vue&type=script&lang=js&"
export * from "./Businessagreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports